/**
 * Set the value of a new or existing Cookie
 * @param cookieName
 * @param cookieValue
 * @param expirationDate sets the "expires" property of the Cookie
 * @param path (optional), defaults to the current location path
 * @param domain (optional), defaults to the current location.host portion of the current document location
 */
const setCookieValue = (
  cookieName: string,
  cookieValue: string,
  expirationDate?: Date,
  path?: string,
  domain?: string,
): void => {
  const key = encodeURIComponent(cookieName);
  const value = encodeURIComponent(cookieValue);
  const keyValue = `${key}=${value}`;

  const expires = expirationDate ? `expires=${expirationDate.toUTCString()}` : null;

  const cookiePath = path ? `path=${path}` : null;

  const cookieDomain = domain ? `domain=${domain}` : null;

  const cookie = [keyValue, expires, cookiePath, cookieDomain]
    .filter((s) => typeof s === 'string' && s.length > 0)
    .join('; ');

  document.cookie = cookie;
};

/**
 * Get the value of a Cookie by name
 * REMARK: refactored to return string instead of string | null or string[]
 * @param cookieName
 */
const getCookieValue = (cookieName: string): string => {
  const cookies = document.cookie.split('; ');

  const result = cookies.findIndex((cookieValue) => {
    return cookieValue.startsWith(cookieName);
  }, cookieName);
  return result !== undefined && result >= 0 ? cookies[result].split('=')[1] : '';
};

/**
 * Delete a Cookie by name
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Notes set expires=0
 * @param cookieName
 * @param path (optional)
 */
const deleteCookie = (cookieName: string, path?: string): void => {
  const key = encodeURIComponent(cookieName);
  const keyValue = `${key}=`;

  const expires = `expires=0`;

  const cookiePath = path ? `path=${path}` : null;

  const cookie = [keyValue, expires, cookiePath]
    .filter((s) => typeof s === 'string' && s.length > 0)
    .join('; ');

  document.cookie = cookie;
};

export { setCookieValue, getCookieValue, deleteCookie };
